// Repli affiché tant que l'API n'a pas encore répondu (blocks === undefined,
// voir Home.jsx) — identique au contenu d'origine. Voir ServicesSection.jsx
// pour la même logique (Studio de thème > Sprint 4).
import RichText from "@/components/RichText";

const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { step: "01", phase: "CADRAGE", title: "Audit & specs", desc: "Estimation chiffrée sous 48h.", color: "#635BFF" } },
  { id: "fallback-2", props: { step: "02", phase: "ARCHITECTURE", title: "Stack & data", desc: "Modélisation, maquettes validées.", color: "#38BDF8" } },
  { id: "fallback-3", props: { step: "03", phase: "DÉVELOPPEMENT", title: "Sprints hebdo", desc: "Démo continue, code review.", color: "#EC4899" } },
  { id: "fallback-4", props: { step: "04", phase: "LANCEMENT", title: "Déploiement", desc: "Monitoring, support continu.", color: "#635BFF" } },
];

const DEFAULTS = {
  heading: "Un pipeline éprouvé, du cadrage au support.",
  eyebrow: "",
  subheading: "",
  // "phase" = rendu d'origine (cartes bordées d'une couleur, libellé de
  // phase). "numbered" = ronds numérotés reliés par un trait, sans couleur
  // ni phase (voir DEFAULT_PROPS.process côté backend).
  steps_style: "phase",
};

export default function ProcessSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const steps = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false);
  const numbered = t.steps_style === "numbered";
  return (
    <section id="processus" className="max-w-[1240px] mx-auto px-6 md:px-10 pt-section-top md:pt-section-top-md scroll-mt-28">
      <div className={numbered ? "text-center max-w-2xl mx-auto" : ""}>
        {t.eyebrow && (
          <RichText as="p" className="text-[13px] font-semibold tracking-wide text-gold uppercase mb-3" html={t.eyebrow} />
        )}
        <RichText
          as="h2"
          className={`font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] text-ink ${numbered ? "" : "max-w-lg"}`}
          html={t.heading}
        />
        {t.subheading && <RichText as="p" preserveParagraphs className="text-[16px] text-graphite mt-4" html={t.subheading} />}
      </div>

      {numbered ? (
        <div className="grid sm:grid-cols-3 gap-5 mt-12 relative">
          {steps.map((block, i) => (
            <div key={block.id} data-block-key={block.id} className="relative rounded-card border-control border-stone bg-white p-6 animate-fade-up" style={{ animationDelay: `${i * 70}ms` }}>
              {i < steps.length - 1 && (
                <span className="hidden sm:block absolute top-[38px] left-full w-5 h-[2px] bg-stone -translate-x-2.5" />
              )}
              <span className="h-11 w-11 rounded-btn bg-gold text-white flex items-center justify-center font-display font-semibold text-[17px]">
                {i + 1}
              </span>
              <RichText as="h3" className="font-display font-semibold text-[17px] text-ink mt-5" html={block.props?.title} />
              <p className="text-[14px] text-graphite mt-2 leading-relaxed">{block.props?.desc}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
          {steps.map((block, i) => (
            <div
              key={block.id}
              data-block-key={block.id}
              className="rounded-card border-control border-stone bg-white p-6 animate-fade-up"
              style={{ animationDelay: `${i * 70}ms`, borderTop: `3px solid ${block.props?.color || "#635BFF"}` }}
            >
              <div className="font-mono text-[12px] text-ash tracking-wider">{block.props?.step} / {block.props?.phase}</div>
              <RichText as="h3" className="font-display font-semibold text-[16.5px] text-ink mt-4" html={block.props?.title} />
              <p className="text-[14px] text-graphite mt-2 leading-relaxed">{block.props?.desc}</p>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
